import { TrackProductDirective } from '@analytics/events';
import type { ParsedProductTrackingConfig } from '@analytics/models';
import { CurrencyPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { getFieldValue, TextInterpolationPipe } from '@core/jss-utils';
import { CrntIcon } from '@essent/current-web-angular';
import type {
  SolarPanelsResultOverviewSummaryComponentFields,
  SolarPanelsResultOverviewSummaryRendering,
} from '@feh/solar-panels-models';
import type { SolarPanelsProductWithCalculations } from '@feh/solar-panels-store';
import { ScFieldValuePipe } from '@innogy/feh/shared';
import { StickyWrapperComponent } from '@legacy/common-ui-common-renderings';
import { CardComponent } from '@legacy/common-ui-partials';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';

@Component({
  selector: 'wl-solar-panels-result-overview-summary-ui',
  standalone: true,
  templateUrl: './solar-panels-result-overview-summary-ui.component.html',
  styleUrls: [
    './solar-panels-result-overview-summary-ui.component.ed.scss',
    './solar-panels-result-overview-summary-ui.component.essent.scss',
  ],
  imports: [
    ScFieldValuePipe,
    CrntIcon,
    StickyWrapperComponent,
    CardComponent,
    RichTextWrapperComponent,
    TrackProductDirective,
    CurrencyPipe,
    TextInterpolationPipe,
  ],
})
export class SolarPanelsResultOverviewSummaryUiComponent {
  readonly rendering =
    input.required<SolarPanelsResultOverviewSummaryRendering>();
  readonly trackingConfig =
    input.required<ParsedProductTrackingConfig<any, any>>();
  readonly product = input<SolarPanelsProductWithCalculations>();

  get fields(): SolarPanelsResultOverviewSummaryComponentFields {
    return this.rendering().fields;
  }

  get isPlacedOnOrderPage() {
    return getFieldValue<boolean>(
      this.rendering(),
      'IsPlacedOnOrderPage',
      false
    );
  }

  get trackMode(): 'product-impression' | 'product-detail' {
    return this.isPlacedOnOrderPage ? 'product-detail' : 'product-impression';
  }

  get maximumAmountOfPanelsTooltip() {
    const description = getFieldValue<string>(
      this.rendering(),
      'MaximumAmountOfPanelsTooltip'
    );

    return { description };
  }

  get recommendedAmountOfPanelsTooltip() {
    const description = getFieldValue<string>(
      this.rendering(),
      'RecommendedAmountOfPanelsTooltip'
    );

    return { description };
  }

  get savingsPerYearTooltip() {
    const description = getFieldValue<string>(
      this.rendering(),
      'SavingsPerYearTooltip'
    );

    return { description };
  }
}
